<template>
  <div class="width100 margin-auto">
    <!-- 头部 -->
    <!-- 内容· -->
    <div class="backwhite width98 margin-auto">
      <div class="pad-bot20 f16 width98 textalign-left dimensional">
        立项报告
      </div>
      <!-- 内容表单 -->
      <div
        class="width100 invoice width98 margin-auto pad-bot40"
        contenteditable="true"
      >
        <div id="printTest" class="textalign-center">
          <h1 class="margin-top100">研究开发项目立项书</h1>
          <div
            class="width70 margin-auto f18 margin-top200"
            style="color: black"
          >
            <p class="flex-betweenNowrapAligns margin-top40">
              单位名称 : <span class="cont_item">{{ companytitle }}</span>
            </p>
            <p class="flex-betweenNowrapAligns margin-top40">
              项目名称 : <span class="cont_item">{{ form.title }}</span>
            </p>
            <p class="flex-betweenNowrapAligns margin-top40">
              项目编号 :
              <span class="cont_item">{{ form.project_number }}</span>
            </p>
            <p class="flex-betweenNowrapAligns margin-top40">
              负 责 人 : <span class="cont_item">{{ forms.nature }}</span>
            </p>
            <p class="flex-betweenNowrapAligns margin-top40">
              承担部门 : <span class="cont_item">{{ forms.name }}</span>
            </p>
            <p class="flex-betweenNowrapAligns margin-top40">
              协作单位 :
              <span class="cont_item">
                <span> {{ forms.numbers == "" ? "" : forms.numbers }}</span>
                <span style="position: relative; left: 450px"
                  >（盖章）</span
                ></span
              >
            </p>
            <p class="flex-betweenNowrapAligns margin-top40">
              立项日期 : <span class="cont_item">{{ forms.date }}</span>
            </p>
            <p class="flex-betweenNowrapAligns margin-top40">
              批准日期 :
              <span class="cont_item">{{
                approval_time == null ? "" : approval_time
              }}</span>
            </p>
          </div>

          <div
            class="width90 margin-auto margin-top300 textalign-left"
            style="color: black"
          >
            <p class="little_title pad-top20">一、立项依据</p>
            <div class="width100 margin-top20">
              <p>（一） 国内外现状、水平和发展趋势</p>
              <div class="little_cont">
                {{ allvalue[0].value == "" ? "" : allvalue[0].value }}
              </div>
            </div>
            <div class="width100 margin-top20">
              <p>（二）项目对本企业的作用与意义</p>
              <div class="little_cont">
                {{ allvalue[1].value == "" ? "" : allvalue[1].value }}
              </div>
            </div>
            <div class="width100 margin-top20">
              <p>（三）项目预期达到的技术水平</p>
              <div class="little_cont">
                {{ allvalue[2].value == "" ? "" : allvalue[2].value }}
              </div>
            </div>
            <div class="width100 margin-top20">
              <p>（四）项目预期市场前景</p>
              <div class="little_cont">
                {{ allvalue[3].value == "" ? "" : allvalue[3].value }}
              </div>
            </div>
          </div>

          <div
            class="width90 margin-auto margin-top80 textalign-left"
            style="color: black"
          >
            <p class="little_title">二、研究开发内容和目标</p>
            <div class="width100 margin-top20">
              <p>（一）项目主要内容</p>
              <div class="little_cont">
                {{ allvalue[4].value == "" ? "" : allvalue[4].value }}
              </div>
            </div>
            <div class="width100 margin-top20">
              <p>（二）项目关键技术</p>
              <div class="little_cont">
                {{ allvalue[5].value == "" ? "" : allvalue[5].value }}
              </div>
            </div>
            <div class="width100 margin-top20">
              <p>（三）技术创新点</p>
              <div class="little_cont">
                {{ allvalue[6].value == "" ? "" : allvalue[6].value }}
              </div>
            </div>
            <div class="width100 margin-top20">
              <p>（四）技术指标和经济指标</p>
              <div class="little_cont">
                {{ allvalue[7].value == "" ? "" : allvalue[7].value }}
              </div>
            </div>
          </div>

          <div
            class="width90 margin-auto margin-top80 textalign-left"
            style="color: black"
          >
            <p class="little_title">三、研究开发方法及技术路线</p>
            <div class="width100 margin-top20">
              <div class="little_cont">
                {{ allvalue[8].value == "" ? "" : allvalue[8].value }}
              </div>
            </div>
          </div>

          <div
            class="width90 margin-auto margin-top80 textalign-left"
            style="color: black"
          >
            <p class="little_title">四、现有研究开发基础</p>
            <div class="width100 margin-top20">
              <div class="little_cont">
                {{ allvalue[9].value == "" ? "" : allvalue[9].value }}
              </div>
            </div>
          </div>

          <div
            class="width90 margin-auto margin-top80 textalign-left"
            style="color: black"
          >
            <p class="little_title">五、研究开发项目组人员名单</p>
            <div class="width100 margin-top20">
              <table class="width100 textalign-center">
                <tr style="font-weight: 600">
                  <td class="width15">姓名</td>
                  <td class="width10">性别</td>
                  <td class="width15">学历</td>
                  <td class="width20">专业</td>
                  <td class="width20">职称</td>
                  <td class="width20">本项目承担工作</td>
                </tr>
                <tr v-for="(item, index) in page_pipo" :key="index">
                  <td class="width15">{{ item.realname }}</td>
                  <td class="width10">{{ item.bind_info.sex }}</td>
                  <td class="width15">{{ item.bind_info.qualification }}</td>
                  <td class="width20">{{ item.bind_info.major }}</td>
                  <td class="width20">{{ item.bind_info.rank }}</td>
                  <td class="width20 textalign-left">{{ item.role }}</td>
                </tr>
              </table>
            </div>
          </div>

          <div
            class="width90 margin-auto margin-top80 textalign-left"
            style="color: black"
          >
            <p class="little_title">六、计划工作进度</p>
            <div class="width100 margin-top20">
              <table class="width100 textalign-center">
                <tr style="font-weight: 600">
                  <td class="width25">计划名</td>
                  <td class="width20">起止时间</td>
                  <td class="width10">责任人</td>
                  <td class="width15">参与成员</td>
                  <td class="width30">计划目标</td>
                </tr>
                <tr v-for="(item, index) in page_task" :key="index">
                  <td class="width25">{{ item.title }}</td>
                  <td class="width20">
                    <p>{{ item.start_date.substring(0, 10) }}</p>
                    <p>{{ item.end_date.substring(0, 10) }}</p>
                  </td>
                  <td class="width10">{{ item.user.nickname }}</td>
                  <td class="width15">
                    <span
                      v-for="(_item, _index) in item.participants"
                      :key="_index"
                      class="margin-right5"
                      >{{ _item.realname }}</span
                    >
                  </td>
                  <td class="width30 textalign-left">{{ item.remark }}</td>
                </tr>
              </table>
            </div>
          </div>

          <div
            class="width90 margin-auto margin-top80 textalign-left"
            style="color: black"
          >
            <p class="little_title">七、费用预算情况</p>
            <div class="width100 margin-top30">
              <table class="width100 textalign-center">
                <tr style="font-weight: 600">
                  <td class="width70 textalign-left">费用类型</td>
                  <td class="width30 textalign-left">预算（元）</td>
                </tr>
                <tr v-for="(item, index) in page_total" :key="index">
                  <td class="width70 textalign-left">{{ item.cate.name }}</td>
                  <td class="width30 textalign-left">{{ item.fee_plan }}</td>
                </tr>
              </table>
            </div>
          </div>

          <div
            class="width90 margin-auto margin-top80 textalign-left"
            style="color: black"
          >
            <p class="little_title">八、立项审批意见</p>
            <div class="width100 margin-top20">
              <table class="width100 textalign-center">
                <tr>
                  <td class="width30" style="height: 100px">项目小组意见</td>
                  <td class="width70">
                    <p class="flex-aroundnowrapcev">
                      <span>同意立项。</span> <span> </span>
                    </p>
                    <p class="flex-aroundnowrapcev margin-top20">
                      <span>签字：</span> <span>日期：</span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td class="width30" style="height: 100px">项目负责人意见</td>
                  <td class="width70">
                    <p class="flex-aroundnowrapcev">
                      <span>同意立项。</span> <span> </span>
                    </p>
                    <p class="flex-aroundnowrapcev margin-top20">
                      <span>签字：</span> <span>日期：</span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td class="width30" style="height: 100px">总裁办意见</td>
                  <td class="width70">
                    <p class="flex-aroundnowrapcev">
                      <span>同意立项。</span> <span> </span>
                    </p>
                    <p class="flex-aroundnowrapcev margin-top20">
                      <span>签字：</span> <span>日期：</span>
                    </p>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>

      <p class="margin-top10 textalign-left f12" style="color: #6a7589">
        虚线内为打印内容,打印前请核对！
      </p>
      <div class="textalign-right">
        <el-button @click="dialognull()">取 消</el-button>
        <el-button
          type="primary"
          class="cursorpointer margin-top20"
          v-print="'#printTest'"
          @click="Savechanges()"
        >
          打 印
        </el-button>
      </div>
    </div>
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
    
<script>
import BUS from "@/BUS/BUS";
import {
  Projectdetail,
  pipoList,
  projecttaskindex,
  entrdfeetotal,
} from "@/api/Center/Center.api";
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      form: {
        title: "",
        progress: "",
        project_number: "",
        industry_small_text: "",
        industry_text: "",
        keyword: "",
      },

      approval_time: "",
      finish_status: "",
      finish_time: "",
      rduser: [],
      forms: {
        name: "",
        numbers: "",
        date: "",
        nature: "",
        desc: "",
      },
      authority_text: "",
      approval: "",
      finishte: "",
      centerNums: "",
      companytitle: "",
      allvalue: [],
      page_pipo: [],
      page_task: [],
      page_total: [],
    };
  },

  methods: {
    Savechanges() {
      BUS.$emit("prontreport", "yess");
    },
    dialognull() {
      BUS.$emit("prontreport", "yess");
    },
  },

  created() {
    this.centerNums = window.sessionStorage.getItem("centerNums");
    this.authority_text = window.sessionStorage.getItem("authority_text");
    this.companytitle = window.sessionStorage.getItem("companytitle");
    Projectdetail({ id: window.sessionStorage.getItem("centerNums") }).then(
      (res) => {
        if (res.data.code == 200) {
          this.form.title = res.data.data.title;
          this.finish_status = res.data.data.finish_status;
          this.form.project_number = res.data.data.project_number;
          this.form.keyword = res.data.data.keyword;
          this.form.industry_small_text = res.data.data.industry_small_text;
          this.form.industry_text = res.data.data.industry_text;
          this.form.progress = res.data.data.progress;
          this.forms.date = res.data.data.start_date;
          this.forms.name = res.data.data.research_dev_title;
          this.forms.numbers = res.data.data.cooperation;
          this.forms.nature = res.data.data.manager_name;
          this.forms.desc = res.data.data.remark;
          this.approval = res.data.data.approval_text;
          this.approval_time = res.data.data.approval_time;
          this.finish_time = res.data.data.finish_time;
          this.finishte = res.data.data.finish_text;
          this.rduser = res.data.data.rduser;
          this.allvalue = res.data.data.value;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      }
    );
    pipoList({ dev_project_id: this.centerNums }).then((res) => {
      if (res.data.code == 200) {
        this.page_pipo = res.data.data;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
    projecttaskindex({ project_id: this.centerNums, page: 1, limit: 30 }).then(
      (res) => {
        if (res.data.code == 200) {
          this.page_task = res.data.data.data;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      }
    );
    entrdfeetotal({ project_id: this.centerNums }).then((res) => {
      if (res.data.code == 200) {
        let total = {
          fee_plan: 0,
          cate: {
            name: "总计",
          },
          amount: 0,
        };
        let allcont = [];
        let amoubtcont = [];
        this.page_total = res.data.data;
        this.page_total.forEach((i) => {
          allcont.push(i.fee_plan);
          amoubtcont.push(i.amount);
          if (i.rate != null) {
            i.rate = i.rate + "%";
          }
        });
        allcont.forEach((item) => {
          total.fee_plan = total.fee_plan + Number(item);
        });
        amoubtcont.forEach((item) => {
          total.amount = total.amount + item;
        });
        this.page_total.push(total);
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
};
</script>
    
<style scoped>
/* 调用window.print()时生效的样式 */
@media print {
  @page {
    /* 横向 */
    /* size: landscape; */
    /* 去除浏览器默认页眉页脚 */
    margin: 0;
  }
  /* 给需要打印的区域内或同级不需要打印的元素加上这个类 */
  .noprint {
    display: none;
  }
  /* 这里的id我用于选中modal，然后给其中背景色设置为透明，去掉弹窗头和脚及阴影 */
  #printTest {
    /* 默认打印内容区背景色*/
    /* -webkit-print-color-adjust: exact; */
    border: solid white !important;
    background-color: #fff !important;
  }
}

/* 需要打印的区域*/
.printable {
  display: block;
}
.invoice {
  width: 100%;
  line-height: 30px;
  border-radius: 3px;
  margin: 20px 0 0 0;
  background: #ecf8f9;
  border: 1px dashed #52c5cb;
}
.cont_item {
  display: inline-block;
  width: 85%;
  border-bottom: 1px solid black;
  font-size: 16px;
  text-align: left;
  /* margin-top: 40px; */
}
.little_title {
  width: 100%;
  text-align: left;
  font-size: 18px;
  font-weight: 600;
}
.little_cont {
  border: 1px solid black;
  width: 97%;
  min-height: 100px;
  margin: 10px 0 0 10px;
  padding: 10px;
  text-indent: 2em;
}
table {
  width: 100%;
  margin: 10px 0 0 10px;
  border-collapse: collapse;
}

tr {
  width: 100%;
}
td {
  padding: 0 10px 0 10px;
  height: 40px;
  border: 1px solid black;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>
    